/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 29 2024
 **/
/* eslint-disable @typescript-eslint/no-explicit-any */

import { EmotionJSX } from "@emotion/react/types/jsx-namespace";
import { domElementList } from "@/frameworks/designStuff/system";
import { withTooltip } from "../../components/Contents/Tip";
import { Typography } from "./index";

type TypoTooltipProps = DesignStuff.WithTooltip.Props<
	DesignStuff.Typography.Props & React.AllHTMLAttributes<HTMLElement>
>;

type TypoTooltipBaseType = (props: TypoTooltipProps) => EmotionJSX.Element;

type TypoTooltipTagsType = {
	[tag in keyof JSX.IntrinsicElements]: TypoTooltipBaseType;
};

interface TypographyTooltip extends TypoTooltipTagsType, TypoTooltipBaseType {}

const TypographyTooltip = withTooltip(Typography) as TypographyTooltip;

domElementList.forEach((dom: any) => {
	// @ts-ignore
	TypographyTooltip[dom] = withTooltip(Typography[dom]);
});

export default TypographyTooltip;
